import prop from "ramda/src/prop";
import sortBy from "ramda/src/sortBy";

export const sortByQuestionOrder = sortBy(prop("questionOrder"));
